module.exports = "/static/assets/2fd9d2c7be81282708dc8e0951f8b221.png";